import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import { scoreComment } from "../../actions/studensts";
import { useState } from "react";
import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import { FiMessageSquare, FiArrowLeft } from "react-icons/fi";

export default function ScoreComment() {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const id = useLocation().state;
  const [text, setText] = useState("");
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading(false);
      navigate(`/main/score/score_pending`);
    }, 2000);
  }

  const handleSend = async () => {
    if (msg.length === 0) {
      setShowDengerAlert(true);
      setText("Can't save an Comment");
      return;
    }
    setLoading(true);
    const res = await scoreComment(
      id,
      msg,
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  return (
    <div className="min-h-screen px-4 sm:px-8 py-6">
      <div className="max-w-2xl mx-auto space-y-6">

        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center">
              <FiMessageSquare size={22} className="text-indigo-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">Write a Comment</h1>
              <p className="text-slate-400 text-sm">Score pending feedback</p>
            </div>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 text-slate-300 hover:text-white px-4 py-2 rounded-lg transition-all"
          >
            <FiArrowLeft size={14} /> Back
          </button>
        </div>

        {/* Comment Card */}
        <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 space-y-4">
          {showSuccessAlert && <AlertSuccess text={text} />}
          {showDengerAlert && <AlertDenger text={text} />}

          <textarea
            name="issue"
            rows="6"
            placeholder="Write a Comment here..."
            className="w-full bg-white/5 border border-white/10 rounded-xl resize-none p-4 text-white placeholder-slate-500 outline-none focus:border-indigo-500/50 transition-colors"
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
          ></textarea>

          <Button
            text={!loading ? "Save" : <Loading />}
            color="bg-indigo-600 hover:bg-indigo-500 disabled:bg-white/10 disabled:text-slate-500"
            disabled={loading}
            onClick={handleSend}
          />
        </div>
      </div>
    </div>
  );
}
